/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as Badge } from "./Badge";
export type { BadgeProps } from "./BadgeProps";
